import $ from 'jquery';
import TickTock from 'tick-tock';
import Random from './Random';

const DELAY = 40;

export default class Mission {
  constructor(element) {
    this.element = element;
    this.$element = $(this.element);
    this.$output = this.addOutput();
    this.options = this.getOptions();
    this.timer = new TickTock();
    this.currentIndex = this.getRandomIndex();
    this.animate();
  }

  getRandomIndex() {
    return Random(0, this.options.length);
  }

  addOutput() {
    const $output = $('<div class="output"></div>');
    this.$element.append($output);
    return $output;
  }

  getOptions() {
    const options = [];
    const $items = this.$element.find('li');
    if (!$items.length) return options;
    $items.each((i, item) => {
      options.push($(item).text());
    });
    return options;
  }

  get currentIndex() {
    return this.index;
  }

  set currentIndex(value) {
    this.index = value >= this.options.length ? 0 : value;
  }

  animate() {
    let i = 0;
    const source = this.options[this.currentIndex];
    this.$output.addClass('show');
    this.timer.setInterval('typing', () => {
      if (i <= source.length) {
        source.substr(0, i);
        this.$output.text(source.substr(0, i));
        i += 1;
      } else {
        this.next();
      }
    }, DELAY);
  }

  next() {
    this.timer.clear('typing');
    this.timer.setTimeout('change', this.change.bind(this), 1000);
  }

  change() {
    this.timer.clear('change');
    this.$output.removeClass('show');
    this.currentIndex = this.currentIndex + 1;
    this.timer.setTimeout('animate', this.animate.bind(this), 1000);
  }
}
